import { render } from "./ScrollWrap.vue?vue&type=template&id=b82c0fa2&ts=true"
import script from "./ScrollWrap.vue?vue&type=script&lang=ts"
export * from "./ScrollWrap.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "@/styles/components/scrollWrap.scss?vue&type=style&index=0&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__